/**
 * **요금·결제(구독·청구 관리) — 어휘·말·거르기·요청 한 곳**(설계안 `docs/planning/subscription-billing-admin-20261021.md` §10.1 ·
 * §11.5 · 결제 방식 §21 — 10-23 선결제가 약정·위약금을 대체). 의존성 없는 순수 모듈이다(Vue·Element·`@/` 별칭 금지 — 단위 시험이 node
 * 에서 그대로 읽는다).
 *
 * 서버와의 계약(§11.2·§21.5, 관리 세션 admin·mng — 판매자가 오투오페이먼트다):
 *
 * - `GET /api/admin/subscriptions` — 질의 `product`·`status`·`planCode`·`termMonths`·`q` + 페이징(`utils/pagedList` 봉투). 행의 결제 방식
 *   `termMonths`(0 무약정·6·12·18·24 선결제)·`price`(한 번 결제 금액)·`listPrice`(월 정가)·지금 낸 기간 `paidFrom`~`paidThrough`·다음
 *   결제 `nextChargeAt`(없으면 null).
 * - `GET /api/admin/subscriptions/{id}` — 행 + 해지 칸(누가·사유).
 * - `POST /api/admin/subscriptions/{id}/stop` `{reason}` — 해지(화면 이름 「자동 결제 멈추기」). 덮인 끝까지 쓰고 그 뒤 잠긴다(§21.4 —
 *   위약금·폐업 확인 없음). 결과를 모르는 결제를 서버가 거래 조회로 맞추지 못하면 409 `CHARGE_PENDING`(중도 해지도 같다).
 * - `GET /api/admin/subscription-charges` — 질의 `subscriptionId`·`from`·`to`·`q` + 페이징. 줄의 `kind` 는 화면이 사업자 추가(`ADDON`)만
 *   가려 읽는다(§26.7 — 옛 dev 위약금 줄 `PENALTY` 는 열·거르기 없이 같은 칸으로, §21.5).
 * - `POST /api/admin/subscription-charges/{chargeId}/cancel` — 청구 취소(**전액·사유 필수**, 구독료 줄은 **해지 동반** — Q10·Q11, 사업자
 *   추가 줄은 그 줄만 돌려주고 해지하지 않는다 — §26.6). 헥토 갈래(취소가 안 됨)는 200 값으로 답한다(§11 머리 — 줄의 `canceledDtm` 이
 *   비고 `cancelResult*` 가 찬다).
 * - 오더엔 멀티 요금제(§26 — SQL 105): 행·상세에 `units`(지금 상한 — 배달앱마다 넣어 둘 수 있는 계정 수, 이번 기간에 낸 수까지 · §26.15 — 신청
 *   전 null) · `nextUnits`(다음 결제의 사업자 수 — 이용 중 줄이면 상한보다 작다) ·
 *   `bonusMonths`(신청 때 정한 보너스 개월), `price`·`listPrice` 는 지금 사업자 수의 갱신 금액·월 정가다. 청구 줄에 `units`(사업자 추가가
 *   더한 수). POS2LITE 는 새 칸이 null 이고 표시가 바뀌지 않는다. 중도 해지는 구독료 줄만 정산한다(§26.9 — 남은 사업자 추가 줄은 청구
 *   내역의 청구 취소로 따로) — 견적에 서버가 판정한 남은 사업자 추가 줄 `addonLines`(`[{chargeId, amount, units, endsAt}]`, POS2LITE 는
 *   늘 `[]`)가 실리고 창은 그 수만 말한다(다시 세지 않는다). 멀티 구독은 매장이 없어(`store_cd` NULL — 사장님마다) 행·상세·청구 줄의
 *   `owner`(`{name, phone}` — 사장님 이름·휴대폰 숫자만)로 누구의 구독인지 보인다([subscriberOf]).
 * - 중도 해지·환불(§21.10 · 약관 제20조 — SQL 090): `GET …/{id}/termination?rule=OWNER|COMPANY`(서버가 셈한 돌려줄 금액·쓸 수 있는 끝·
 *   셈 근거 · 결과 모르는 결제 `chargePending`) · `POST …/{id}/terminate` `{rule, reason}` → `{subscription, charge, refundAmount}`(실행
 *   때 서버가 다시 셈한다 — 헥토가 거절·답 없음이면 해지하지 않고 200, 청구 취소와 같은 갈래 · 409 `CHARGE_NOT_CANCELABLE`·
 *   `CHARGE_PENDING`). 청구 줄에 `cancelAmount`(취소한 금액 — 승인 금액보다 작으면 부분 환불,
 *   옛 취소 줄은 null = 전액)·`usedUntil`(해지로 앞당긴 쓸 수 있는 끝, null = 기간 끝)이 더해진다.
 * - 3판 매니저 지정(§20.5 — 「유료처럼 쓰는 매장」): `POST /api/admin/subscriptions/grant` `{storeCd, planCode, reason}`(행이 없는 매장도,
 *   지정 중이면 요금제 바꾸기) · `POST …/{id}/ungrant` `{reason}`(409 `NOT_GRANTED`). 행·상세에 `grant`·`grantEndedDtm`·`selfSignup`,
 *   상태에 `GRANTED`(지정)가 더해진다. 기존 매장(셀프가 아닌 매장)의 행은 출시 전에 「시작 전」으로 보인다(§20.3).
 * - 운영 관리 둘(10-30 — SQL 103, 리얼에서도 쓰는 관리 기능): `POST …/{id}/trial-end` `{trialEndDtm}`(null = 지금 — 서버 시계, 값은
 *   `+09:00` ISO · 체험 중에만 · 늘리기도 받는다 · 409 `NOT_IN_TRIAL`·`CHARGE_PENDING`·`STATUS_CHANGED`, 400 `INVALID_REQUEST`) → 바꾼
 *   뒤 상세 · `POST …/{id}/charge`(본문 없음 — 매일 회차와 같은 판정으로 지금 청구) → `{subscription, charge}`(헥토 거절·답 없음도 200 —
 *   줄의 `result`·`resultCd`·`resultMsg` 가 사유) · 409 `NOT_DUE`(아직 때가 아님)·`NOT_RECURRING`·`CARD_REQUIRED`·`CHARGE_PENDING` ·
 *   503 `CHARGE_OFF`(이 서버는 결제를 보내지 않음)·`NOT_CONFIGURED`.
 * - 운영자 화면 2판(10-30 저녁 — 설계안 §25, SQL 104): **할 수 있는 일은 서버가 정한다** — 행·상세의 `actions`(동작 코드 목록,
 *   [SUBSCRIPTION_OP])를 서버 순수 함수 한 곳이 계산하고, 화면은 「코드 ∈ actions ∧ 세션 권한」일 때만 단추를 그린다([opAllowed] —
 *   화면이 상태·신청 칸으로 따로 판정하지 않는다). `trial-end` 는 이제 `{trialEndDtm, reason}`(시작 전·체험 중·유예·멈춤 — 거절
 *   `TRIAL_UNAVAILABLE`) · 새 `POST …/trial` `{storeCd, trialEndDtm, reason}`(행 없는 매장도) · `POST …/{id}/withdraw` `{reason}`(신청 취소 —
 *   409 `NOT_RECURRING`·`NOT_IN_TRIAL`·`CHARGE_PENDING`) · `POST …/{id}/extend` `{usableUntilDtm, reason}`(이용 기간 늘리기 — 409
 *   `NOT_ACTIVE`, 상세 `extend: {chargeId, periodEnd, usableUntil}`) · 지정 `untilDtm`(null = 무기한, `grant.untilDtm`) · 상세
 *   `logs`(작업 기록 최근 50 — 값은 기계 값, 한글 줄은 [logLinesOf]). 응답은 모두 바뀐 뒤 상세다.
 * - 카드 할부·결제 카드(11-02 — 설계안 `docs/planning/subscription-installment-card-20261102.md` §3.6·§6, SQL 110 — **표시만**, 고르기는
 *   앱): 행·상세에 `installmentMonths`(다음 결제의 할부 개월 — 신청 스냅샷, 기간 끝 자동 재결제도 같은 할부 · null·0 일시불)·`cardName`
 *   (지금 카드의 이름)·`cardLast4`(카드번호 뒤 4자리 — 리얼은 헥토 상점 설정 전이라 null 이 흔하다), 청구 줄에 `installmentMonths`(그
 *   결제에 보낸 할부 — 0 일시불, 이 칸 전 줄 null)·`interestFree`(헥토가 알려 준 무이자 — null 모름). 칸이 없는 옛 서버 응답은 결제
 *   방식·상세가 지금 그대로이고, 청구 내역의 할부 칸만 「—」(모름)다.
 *
 * 가격·선결제 할인·기능 권한의 **판정은 서버 순수 함수 한 곳**이다(§4.1·§21.2). 이 화면은 서버가 준 값(`price`·`features` …)을 말로 옮길
 * 뿐 다시 셈하지 않는다. 서버는 어휘만 내리고 한글 문구는 이 파일이 만든다.
 */

// 확장자를 적는 이유: 단위 시험이 이 파일을 node 에서 그대로 읽는다(node ESM 은 확장자를 추론하지 않는다)
import { numberText } from './formatterNum.js'
import { formatKst, formatKstIso, kstTodayLocal } from './kstDate.js'
import { pageRows } from './pagedList.js'
import { STORE_SEARCH_PLACEHOLDER } from './storeSearchText.js'
import { telText } from './telNumber.js'

/**
 * 사이드 메뉴 「사업장 관리 > 요금·결제」의 라우트 — appserver SQL 082 가 `sys_resources` 에 넣는 값과 같아야 메뉴 클릭이 빈 화면이 되지
 * 않는다(§12 082).
 */
export const SUBSCRIPTION_ADMIN_PATH = '/v/business/subscription/list'

/** 관리 API 의 뿌리 둘 — 세션 경로(`ResourceServerConfig.SESSION_AUTH_API_PATHS`, §11.2) */
export const SUBSCRIPTION_ADMIN_API = '/api/admin/subscriptions'
export const SUBSCRIPTION_CHARGE_API = '/api/admin/subscription-charges'

/**
 * 세션 액션 id — SQL 082 의 `sys_action` 다섯 + 084 의 지정 둘 + 090 의 중도 해지 둘 + 103 의 체험 끝·지금 청구 둘 + 104 의 매장 체험·신청
 * 취소·이용 기간 늘리기 셋과 같은 문자열
 */
export const SUBSCRIPTION_ADMIN_ACTION = Object.freeze({
  /** `GET /api/admin/subscriptions` — 라우터 가드의 `meta.requiredAction` 이기도 하다(이 화면이 반드시 부르는 조회) */
  SEARCH: 'SubscriptionAdminSearch',
  /** `GET /api/admin/subscriptions/{id}` */
  GET: 'SubscriptionAdminGet',
  /** `POST /api/admin/subscriptions/{id}/stop` */
  STOP: 'SubscriptionAdminStop',
  /** `GET /api/admin/subscription-charges` */
  CHARGE_SEARCH: 'SubscriptionChargeSearch',
  /** `POST /api/admin/subscription-charges/{chargeId}/cancel` */
  CHARGE_CANCEL: 'SubscriptionChargeCancel',
  /** `POST /api/admin/subscriptions/grant` */
  GRANT: 'SubscriptionAdminGrant',
  /** `POST /api/admin/subscriptions/{id}/ungrant` */
  UNGRANT: 'SubscriptionAdminUngrant',
  /** `GET /api/admin/subscriptions/{id}/termination` — 중도 해지 셈 */
  TERMINATION: 'SubscriptionAdminTermination',
  /** `POST /api/admin/subscriptions/{id}/terminate` — 중도 해지·환불 */
  TERMINATE: 'SubscriptionAdminTerminate',
  /** `POST /api/admin/subscriptions/{id}/trial-end` — 체험 기간 정하기 */
  TRIAL_END: 'SubscriptionAdminTrialEnd',
  /** `POST /api/admin/subscriptions/{id}/charge` — 지금 청구 */
  CHARGE: 'SubscriptionAdminCharge',
  /** `POST /api/admin/subscriptions/trial` — 매장 체험(행이 없는 매장도) */
  TRIAL_START: 'SubscriptionAdminTrialStart',
  /** `POST /api/admin/subscriptions/{id}/withdraw` — 신청 취소 */
  WITHDRAW: 'SubscriptionAdminWithdraw',
  /** `POST /api/admin/subscriptions/{id}/extend` — 이용 기간 늘리기 */
  EXTEND: 'SubscriptionAdminExtend',
})

/** 지금 누를 수 있는 동작 — 서버 `SubscriptionAdminRules.actionsOf` 가 행·상세의 `actions` 에 싣는 코드(§25.3, 순서도 서버와 같다) */
export const SUBSCRIPTION_OP = Object.freeze({
  TRIAL_SET: 'TRIAL_SET',
  GRANT: 'GRANT',
  UNGRANT: 'UNGRANT',
  CHARGE_NOW: 'CHARGE_NOW',
  WITHDRAW: 'WITHDRAW',
  STOP: 'STOP',
  TERMINATE: 'TERMINATE',
  EXTEND: 'EXTEND',
})

/**
 * 동작 → 그 단추가 부르는 입구의 세션 액션(전부 있어야 한다). 중도 해지는 창이 열리면 셈을 읽으므로 셈 읽기·실행 둘이다 — 없는 액션의
 * 요청은 403(= 로그아웃)이다.
 */
const OP_ACTIONS = Object.freeze({
  [SUBSCRIPTION_OP.TRIAL_SET]: [SUBSCRIPTION_ADMIN_ACTION.TRIAL_END],
  [SUBSCRIPTION_OP.GRANT]: [SUBSCRIPTION_ADMIN_ACTION.GRANT],
  [SUBSCRIPTION_OP.UNGRANT]: [SUBSCRIPTION_ADMIN_ACTION.UNGRANT],
  [SUBSCRIPTION_OP.CHARGE_NOW]: [SUBSCRIPTION_ADMIN_ACTION.CHARGE],
  [SUBSCRIPTION_OP.WITHDRAW]: [SUBSCRIPTION_ADMIN_ACTION.WITHDRAW],
  [SUBSCRIPTION_OP.STOP]: [SUBSCRIPTION_ADMIN_ACTION.STOP],
  [SUBSCRIPTION_OP.TERMINATE]: [SUBSCRIPTION_ADMIN_ACTION.TERMINATION, SUBSCRIPTION_ADMIN_ACTION.TERMINATE],
  [SUBSCRIPTION_OP.EXTEND]: [SUBSCRIPTION_ADMIN_ACTION.EXTEND],
})

/**
 * **이 단추를 그리는가** — 서버가 지금 할 수 있다고 실은 동작(`actions` 에 그 코드)이고 세션이 그 입구의 액션을 다 가진다. 상세 창의 모든
 * 동작 단추가 이 규칙 하나로 보이고 숨는다(§25.2 — 할 수 없으면 숨긴다, 흐린 단추 없음). `actions` 가 없는 응답(옛 서버)은 아무 동작도
 * 그리지 않는다. 순수.
 *
 * @param {?{actions: ?Array<string>}} detail 행·상세
 * @param {string} op [SUBSCRIPTION_OP]
 * @param {function(string): boolean} can 세션 액션 판정(`checkAuthActionAccess`)
 * @returns {boolean}
 */
export function opAllowed(detail, op, can) {
  const needs = OP_ACTIONS[op]

  return (
    !!detail &&
    Array.isArray(detail.actions) &&
    detail.actions.indexOf(op) > -1 &&
    !!needs &&
    typeof can === 'function' &&
    needs.every((action) => can(action))
  )
}

/** 지정을 풀 수 없음 — 서버 `OwnerError.NOT_GRANTED`(409, 그 사이 이미 풀렸다) */
export const NOT_GRANTED_CODE = 'NOT_GRANTED'

/** 지금 청구할 때가 아님 — 서버 `OwnerError.NOT_DUE`(409, 덮인 끝이 아직 하루 넘게 남았다) */
export const NOT_DUE_CODE = 'NOT_DUE'

/** 탭 둘 */
export const SUBSCRIPTION_TAB = Object.freeze({ SUBSCRIPTIONS: 'subscriptions', CHARGES: 'charges' })

/** 쓰기 요청의 axios 옵트아웃 — 실패 문장은 그 창 안에서 한 번만 말한다(인터셉터 토스트와 두 말 금지) */
export const SUBSCRIPTION_WRITE_CONFIG = Object.freeze({ showErrorMessage: false })

/** 목록의 기본 정렬 — 구독은 신청·등록 최근 것부터, 청구는 최근 시도부터 */
export const SUBSCRIPTION_DEFAULT_SORT = Object.freeze({ sortProp: 'subscriptionId', sortOrder: 'descending' })
export const CHARGE_DEFAULT_SORT = Object.freeze({ sortProp: 'requestedDtm', sortOrder: 'descending' })

/** 플러스 전용 기능 코드(§4.1) — `tbl_subscription_plan.features` 의 글자 */
export const PLUS_FEATURES = Object.freeze(['ACCEPT_TIME_RULES', 'SOLDOUT_SYNC'])

/** 화면 문구 — i18n 키(한국어 문장 그대로) */
export const SUBSCRIPTION_TEXT = Object.freeze({
  tabSubscriptions: '구독',
  tabCharges: '청구 내역',
  intro:
    'POS2 Lite(매장마다)와 오더엔 멀티(사장님마다)의 요금제 구독과 청구 내역입니다. 결제 금액은 서버가 계산한 값입니다.',
  filterProduct: '상품',
  filterStatus: '상태',
  filterPlan: '요금제',
  filterTerm: '결제 방식',
  filterPeriod: '시도일',
  filterQuery: '검색어',
  filterQueryPlaceholder: STORE_SEARCH_PLACEHOLDER,
  filterAll: '전체',
  columnStatus: '상태',
  columnProduct: '상품',
  columnStore: '매장',
  labelOwner: '사장님',
  columnPlan: '요금제',
  columnTerm: '결제 방식',
  columnPrice: '결제 금액',
  columnFeatures: '지금 기능',
  columnTrialEnd: '체험 끝',
  columnApplied: '신청',
  columnCanceled: '해지',
  columnChargeId: '청구 번호',
  columnPeriod: '기간',
  columnInstallment: '할부',
  columnAmount: '금액',
  columnResult: '결과',
  columnRequested: '시도 시각',
  columnCancel: '취소',
  columnActions: '동작',
  detail: '상세',
  detailTitle: '구독 상세',
  sectionBasic: '구독',
  sectionTerm: '결제 방식',
  sectionCancel: '해지',
  labelTrial: '체험 기간',
  labelPaidPeriod: '지금 낸 기간',
  labelNextCharge: '다음 결제',
  labelCard: '결제 카드',
  labelCanceledBy: '해지한 사람',
  labelCancelReason: '사유',
  termNone: '무약정',
  termMonthly: '월 결제',
  installmentNone: '일시불',
  labelUnits: '사업자 수',
  labelBonus: '보너스',
  addonMark: '사업자 추가',
  addonCanceledDone: '사업자 추가 결제를 취소했습니다. 구독은 그대로입니다.',
  notCanceled: '해지하지 않음',
  showCharges: '청구 내역',
  stop: '자동 결제 멈추기',
  stopTitle: '자동 결제 멈추기',
  stopReason: '해지 사유',
  stopDone: '자동 결제를 멈췄습니다.',
  cancelCharge: '청구 취소',
  cancelTitle: '청구 취소',
  cancelReason: '취소 사유',
  reasonPlaceholder: '까닭을 적어 주십시오.',
  reasonRequired: '사유를 적어 주십시오.',
  confirm: '실행',
  close: '닫기',
  subscriptionsEmpty: '조건에 맞는 구독이 없습니다.',
  chargesEmpty: '조건에 맞는 청구가 없습니다.',
  chargeScope: '구독 번호',
  chargeScopeClear: '모든 구독 보기',
  canceledDone: '청구를 취소했습니다. 구독도 해지했습니다.',
  writeFailed: '요청을 처리하지 못했습니다.',
  loadFailed: '구독 정보를 읽지 못했습니다.',
  labelSignup: '가입 경로',
  signupSelf: '셀프',
  signupLegacy: '기존',
  sectionGrant: '지정',
  notGranted: '지정하지 않음',
  labelGrantedDtm: '지정한 때',
  labelGrantedBy: '지정한 사람',
  labelGrantReason: '사유',
  labelGrantEnded: '마지막 지정 끝',
  labelGrantUntil: '지정 끝',
  grantForever: '무기한',
  grant: '요금제 지정',
  grantChange: '지정 바꾸기',
  grantStore: '매장 지정',
  grantTitle: '요금제 지정',
  grantIntro: '결제 없이 이 요금제를 낸 것처럼 씁니다. 청구·잠금·체험 안내가 없습니다.',
  grantStoreLabel: '매장',
  grantPlanLabel: '요금제',
  grantReason: '지정 사유',
  grantStoreRequired: '매장을 골라 주십시오.',
  grantPlanRequired: '요금제를 골라 주십시오.',
  grantDone: '요금제를 지정했습니다.',
  ungrant: '지정 풀기',
  ungrantTitle: '지정 풀기',
  ungrantIntro: '지정을 풀면 일반 매장과 같아집니다.',
  ungrantReason: '푸는 사유',
  ungrantRecurring: '정기결제가 켜져 있어 지정을 풀면 다음 결제 회차에 결제돼요.',
  ungrantDone: '지정을 풀었습니다.',
  notGrantedChanged: '그 사이 지정이 이미 풀렸습니다. 다시 읽었습니다.',
  terminate: '중도 해지·환불',
  terminateTitle: '중도 해지·환불',
  terminateRule: '까닭',
  terminateRuleRequired: '까닭을 골라 주십시오.',
  terminateNoCharge: '돌려줄 결제가 없어요 — 해지만 해요',
  terminateAlreadyRefunded: '이미 환불한 결제예요',
  terminateWithRefund: '환불하고 해지',
  terminateOnly: '해지',
  reason: '사유',
  pickMoment: '날짜·시각 고르기',
  pickRequired: '날짜와 시각을 골라 주십시오.',
  pickPast: '지금보다 뒤의 시각을 골라 주십시오.',
  trialSet: '체험 기간 정하기',
  trialStart: '체험 시작',
  trialEnd: '체험 기간 바꾸기',
  trialRestart: '다시 체험',
  trialEndCurrent: '지금 체험 기간',
  trialEndNew: '새 체험 끝',
  trialEndNow: '지금 끝내기',
  trialEndApplied: '체험이 끝나면 신청한 요금제로 결제돼요. 바로 결제하려면 [지금 청구]를 누르세요.',
  trialEndNotApplied: '신청이 없으면 체험이 끝난 뒤 유예 기간이 지나 배달 연동이 잠겨요.',
  trialSetApplied: '체험이 끝나면 신청한 요금제로 결제돼요.',
  trialSetCanceled: '해지한 구독이라 체험이 끝나면 바로 배달 연동이 잠겨요.',
  trialEndSubmit: '바꾸기',
  trialEndDone: '체험 기간을 바꿨습니다.',
  trialStartDone: '체험을 시작했습니다.',
  newStoreWarning:
    '아직 POS2 Lite 를 쓴 적 없는 매장입니다. 체험이 끝나면(신청이 없으면) 배달앱 품절 내보내기 등 플러스 기능이 닫힙니다.',
  storeTrial: '매장 체험',
  storeTrialIntro:
    '고른 매장이 지금부터 고른 때까지 모든 기능을 체험합니다. 결제로 이용 중이거나 지정한 매장은 안 됩니다.',
  withdraw: '신청 취소',
  withdrawIntro: '정기결제 신청만 비웁니다. 체험·유예는 그대로입니다.',
  withdrawDone: '신청을 취소했습니다.',
  extend: '이용 기간 늘리기',
  extendCurrent: '지금 이용 끝',
  extendNew: '새 이용 끝',
  extendPaidEnd: '산 기간의 끝',
  extendBeforeFloor: '산 기간의 끝보다 앞은 고를 수 없습니다.',
  logExtend: '이용 끝',
  extendDone: '이용 기간을 바꿨습니다.',
  sectionLogs: '작업 기록',
  chargeNow: '지금 청구',
  chargeNowIntro: '등록된 카드로 바로 결제합니다. 되돌리려면 청구 내역의 [청구 취소]를 쓰세요.',
  chargeNowRetry: '지난 결제가 거절됐어요. 같은 카드로 다시 보냅니다.',
  chargeNowSubmit: '결제하기',
  chargeNowChecking: '결제 결과를 확인하는 중입니다.',
  chargeNotDue: '아직 결제할 때가 아닙니다',
})

/** 상품 — 서버 `SelfSignupProduct` 글자 */
export const SUBSCRIPTION_PRODUCT_OPTIONS = Object.freeze([
  Object.freeze({ value: 'POS2LITE', label: 'POS2 Lite' }),
  Object.freeze({ value: 'MULTI', label: '오더엔 멀티' }),
])

/** 오더엔 멀티 — 사업자 수 · 보너스 · 사업자 추가가 있는 상품(§26) */
const MULTI_PRODUCT = 'MULTI'

/** 구독 상태 — 서버 `SubscriptionStatus` 글자(저장하지 않고 시각에서 계산한 값). `GRANTED` 는 3판 매니저 지정(§20.5) */
const STATUS_VIEWS = Object.freeze({
  NOT_STARTED: Object.freeze({ label: '시작 전', tone: 'idle' }),
  TRIAL: Object.freeze({ label: '체험 중', tone: 'info' }),
  ACTIVE: Object.freeze({ label: '이용 중', tone: 'success' }),
  GRANTED: Object.freeze({ label: '지정', tone: 'success' }),
  GRACE: Object.freeze({ label: '유예', tone: 'warning' }),
  SUSPENDED: Object.freeze({ label: '멈춤', tone: 'danger' }),
})

export const SUBSCRIPTION_STATUS_OPTIONS = Object.freeze(
  Object.keys(STATUS_VIEWS).map((value) => Object.freeze({ value, label: STATUS_VIEWS[value].label }))
)

/** 요금제 거르기의 선택지 — SQL 079 §2 의 POS2LITE 시드 둘(행의 이름은 서버 `planName` 을 쓴다) */
export const SUBSCRIPTION_PLAN_OPTIONS = Object.freeze([
  Object.freeze({ value: 'LITE', label: '라이트' }),
  Object.freeze({ value: 'LITE_PLUS', label: '라이트 플러스' }),
])

/**
 * 요금제 이름 — 거르기·지정의 POS2LITE 둘 + SQL 105 의 `MULTI` 「오더엔 멀티」(청구 줄의 `planCode` 를 말로 — 지정은 POS2 Lite 만이라
 * 지정 선택지에는 넣지 않는다, §26.9)
 */
const PLAN_NAME_OPTIONS = Object.freeze(
  SUBSCRIPTION_PLAN_OPTIONS.concat([Object.freeze({ value: 'MULTI', label: '오더엔 멀티' })])
)

/** 결제 방식 개월 — SQL 087 `tbl_subscription_term` 의 POS2LITE 다섯(0 = 무약정, 나머지는 그 개월을 한 번에 선결제 — §21.1) */
const TERM_MONTHS = Object.freeze([0, 6, 12, 18, 24])

/** 청구 결과 — `tbl_subscription_charge.result` 글자 */
const CHARGE_RESULT_VIEWS = Object.freeze({
  REQUESTED: Object.freeze({ label: '보내는 중', tone: 'warning' }),
  UNKNOWN: Object.freeze({ label: '확인 중', tone: 'warning' }),
  APPROVED: Object.freeze({ label: '승인', tone: 'success' }),
  DECLINED: Object.freeze({ label: '거절', tone: 'danger' }),
})

/** 앱에서 끈 구독의 해지 주체 — SQL 079 §1 `canceled_by` */
const OWNER_CANCELER = 'OWNER'

/** 원 — 자리 구분(`29,700원`), 값이 없으면 빈 글자 */
export function wonText(amount) {
  return typeof amount === 'number' && Number.isFinite(amount) ? `${numberText(amount)}원` : ''
}

/** ISO 시각 → KST 날짜(`yyyy-MM-dd`), 읽을 수 없으면 빈 글자 */
export function dateText(iso) {
  return formatKstIso('yyyy-MM-dd', iso) || ''
}

/** ISO 시각 → KST 시각(`yyyy-MM-dd HH:mm`), 읽을 수 없으면 빈 글자 */
export function dateTimeText(iso) {
  return formatKstIso('yyyy-MM-dd HH:mm', iso) || ''
}

/**
 * 기간 — `2026-12-20 ~ 2027-01-20`(KST 날짜 — 시각까지 적으려면 [dateTimeText] 를 준다). 끝은 반열림이라 그 날 그 시각 전까지다. 한쪽이라도
 * 없으면 빈 글자
 */
const periodText = (startIso, endIso, format = dateText) => {
  const start = format(startIso)
  const end = format(endIso)

  return start && end ? `${start} ~ ${end}` : ''
}

const labelOf = (options, value) => {
  const found = options.find((option) => option.value === value)
  return found ? found.label : value == null ? '' : String(value)
}

/** 상품 이름 — 모르는 글자는 그대로 */
export function productText(product) {
  return labelOf(SUBSCRIPTION_PRODUCT_OPTIONS, product)
}

/** 요금제 이름 — 청구 줄은 코드만 싣는다(구독 행은 서버 `planName` 을 쓴다). 모르는 코드는 그대로 */
export function planText(planCode) {
  return labelOf(PLAN_NAME_OPTIONS, planCode)
}

/**
 * 결제 방식 이름 — 매달 내는 방식(0 개월)은 POS2 Lite 「무약정」 · 오더엔 멀티 「월 결제」(SQL 105 의 MULTI 0 개월 행 이름 — §26.2),
 * N개월은 「6개월 선결제」. 개월이 없으면(신청 전) 매달 내는 방식의 이름
 */
const termMonthsText = (months, product) => {
  if (typeof months === 'number' && months > 0) return `${months}개월 선결제`

  return product === MULTI_PRODUCT ? SUBSCRIPTION_TEXT.termMonthly : SUBSCRIPTION_TEXT.termNone
}

/**
 * **결제 방식 거르기의 선택지** — 이름은 목록 칸([termText])과 같은 말이고, 상품 거르기가 오더엔 멀티면 멀티의 이름(0 개월 「월
 * 결제」), 그 밖(전체·POS2 Lite)은 POS2 Lite 의 이름이다. 값(개월)은 같다. 순수.
 *
 * @param {?string} product 상품 거르기
 * @returns {Array<{value: number, label: string}>}
 */
export function termOptionsOf(product) {
  return Object.freeze(TERM_MONTHS.map((value) => Object.freeze({ value, label: termMonthsText(value, product) })))
}

/**
 * **구독 행의 상태 배지와 덧붙일 표지** — 상태(시각에서 계산한 서버 값) 하나와, 지정·해지·결제 문제 표지. 순수.
 *
 * @param {?{status: string, canceledDtm: ?string, chargeIssue: ?string, grant: ?object}} row
 * @returns {{label: string, tone: string, marks: Array<{label: string, tone: string}>}}
 */
export function subscriptionStatusViewOf(row) {
  const source = row || {}
  const view = STATUS_VIEWS[source.status] || { label: source.status ? String(source.status) : '', tone: 'idle' }
  const marks = []

  // 지정 중이면 언제까지인지 표지로(§25.8 — 「지정 ~12-31」·「지정 무기한」). 출시 전(「시작 전」)에 지정해 둔 행도 같은 표지다(§20.5)
  if (source.grant) marks.push({ label: grantMarkText(source.grant), tone: 'success' })
  if (source.canceledDtm) marks.push({ label: '해지', tone: 'idle' })
  if (source.chargeIssue === 'DECLINED') marks.push({ label: '결제 거절', tone: 'danger' })
  if (source.chargeIssue === 'PENDING') marks.push({ label: '결제 확인 중', tone: 'warning' })

  return { label: view.label, tone: view.tone, marks }
}

/**
 * **지금 기능** — 체험 / 전부 / 라이트 / 플러스 / 없음(§10.1). 판정은 서버가 한 `features`(지금 열린 기능 — §4.1·§20.5)를 읽는다:
 *
 * - 체험 중은 「체험」(전부 열림).
 * - 시작 전은 「전부」 — 체험 칸이 빈 행은 모두 연다(셀프는 활성화 전, 기존 매장은 출시 전 — §20.5 판정 표 첫 줄). 「체험」이라 부르면
 *   체험 기간이 흐르는 것처럼 읽힌다.
 * - 지정(`GRANTED`)·이용 중·유예는 열린 기능대로 — 플러스 전용 둘이 다 열렸으면 「플러스」, 아니면 「라이트」. 지정한 요금제의 기능을 서버가
 *   `features` 로 준다.
 * - 멈춤이면 「없음」. 멀티는 요금제가 기능을 가르지 않는다(늘 전부 — §4.1) — 「전부」. 순수.
 *
 * @param {?{product: string, status: string, features: ?Array<string>}} row
 * @returns {string}
 */
export function featureTierOf(row) {
  const source = row || {}
  const features = Array.isArray(source.features) ? source.features : []

  if (source.product === 'MULTI' || source.status === 'NOT_STARTED') return '전부'
  if (source.status === 'TRIAL') return '체험'
  if (PLUS_FEATURES.every((code) => features.indexOf(code) > -1)) return '플러스'
  if (source.status === 'SUSPENDED') return '없음'

  return '라이트'
}

/**
 * 가입 경로 — 셀프 가입 매장인가(서버 `selfSignup`, 매장 표지에서 계산 — §20.5). 모르면 빈 글자. 매장의 표지라 오더엔 멀티(사장님 구독 —
 * 매장이 없다)는 늘 빈 글자다: 서버가 멀티 행에 싣는 `selfSignup` 참은 「셀프와 같은 체험 규칙」(§26.13 M1)이라는 뜻이지 가입 경로가 아니다
 */
export function signupPathText(row) {
  if (!row || row.product === MULTI_PRODUCT) return ''
  if (row.selfSignup === true) return SUBSCRIPTION_TEXT.signupSelf
  if (row.selfSignup === false) return SUBSCRIPTION_TEXT.signupLegacy

  return ''
}

/**
 * 사장님 칸 — 서버가 멀티 구독 행·상세·청구 줄에 싣는 사장님(`tbl_owner`)의 이름·휴대폰(숫자만). **서버 칸 이름은 여기 한 곳**이다 — 칸이
 * 없으면(옛 서버) 둘 다 빈 글자
 */
const ownerOf = (source) => {
  const owner = (source && source.owner) || {}
  return { name: owner.name || '', phone: owner.phone || '' }
}

/**
 * **누구의 구독인가** — POS2 Lite 는 매장마다라 매장(이름 · 매장 번호), 오더엔 멀티는 사장님마다라 사장님(이름 · 휴대폰 —
 * `db_changes_2026-10-20_owner-signup.sql`, 멀티 구독에는 매장이 없다). 휴대폰은 다른 관리 화면의 사장님 칸(매장 신청 상세
 * `storeApplicationAdmin.ownerRowsOf`)처럼 가리지 않고 번호 종류로 끊는다(`telNumber.telText`). 구독 행·상세·청구 줄이 같은 칸을 쓴다. 순수.
 *
 * @param {?{product: ?string, storeNm: ?string, storeId: ?string, owner: ?{name: ?string, phone: ?string}}} row
 * @returns {{owner: boolean, label: string, name: string, id: string}} `label` 칸 이름(「매장」·「사장님」), `id` 매장 번호·휴대폰 표기
 */
export function subscriberOf(row) {
  const source = row || {}

  if (source.product === MULTI_PRODUCT) {
    const owner = ownerOf(source)
    return {
      owner: true,
      label: SUBSCRIPTION_TEXT.labelOwner,
      name: owner.name,
      id: owner.phone && telText(owner.phone),
    }
  }

  return { owner: false, label: SUBSCRIPTION_TEXT.columnStore, name: source.storeNm || '', id: source.storeId || '' }
}

/** 누구의 구독인가 한 줄 — 「QA 피자 본점 · S260000899」 · 「김오더 · 010-1234-5678」(상세 칸 · 동작 창 머리 · 청구 취소 확인). 모르면 빈 글자 */
export function subscriberText(row) {
  const who = subscriberOf(row)
  return [who.name, who.id].filter(Boolean).join(' · ')
}

/**
 * **표의 「매장」 칸 두 줄** — 첫 줄 이름(모르면 상품 이름), 둘째 줄 낱말: 매장은 매장 번호, 사장님은 「사장님」 · 휴대폰(매장이 아니라는
 * 표지). 표가 덧붙일 낱말(`extra` — 구독 탭은 가입 경로, 청구 탭은 구독 번호)은 뒤에 잇는다. 낱말은 화면이 `$t` 로 옮겨 ` · ` 로 잇는다. 순수.
 *
 * @param {?object} row 구독 행·청구 줄
 * @param {Array<string>} [extra]
 * @returns {{name: string, tags: Array<string>}}
 */
export function subscriberCellOf(row, extra) {
  const who = subscriberOf(row)
  const base = who.owner ? [SUBSCRIPTION_TEXT.labelOwner, who.id] : [who.id]

  return { name: who.name || productText(row && row.product), tags: base.concat(extra || []).filter(Boolean) }
}

/**
 * **카드 할부인가** — 2 이상의 정수 개월(헥토 `instmtMon` 02~12 — 고를 수 있는 범위는 서버가 정한다, 할부 설계 §3.2). 0·null·칸 없음은
 * 일시불이다(§3.1 — 스냅샷 NULL·0 = 일시불). 구독의 결제 방식([termText])과 청구 줄의 할부([chargeInstallmentText])가 이 판정 하나를 쓴다
 */
const isInstallment = (months) => Number.isInteger(months) && months >= 2

/**
 * **결제 방식 칸** — 무약정(오더엔 멀티는 「월 결제」) / 「6개월 선결제」(§21.1 — N개월이면 그 기간 이용료를 한 번에 내고, 끝나면 같은 기간을
 * 다시 낸다). 다음 결제를 카드 할부로 내면(`installmentMonths` 2 이상 — 신청 스냅샷, 자동 재결제도 같은 할부) 「12개월 선결제 · 3개월
 * 할부」, 일시불(0·null·칸 없는 옛 서버)은 지금 그대로(할부 설계 §6). 목록·상세·지금 청구 창이 같이 쓴다. 순수.
 *
 * @param {?{termMonths: ?number, product: ?string, installmentMonths: ?number}} row
 * @returns {string}
 */
export function termText(row) {
  const source = row || {}
  const term = termMonthsText(source.termMonths, source.product)

  return isInstallment(source.installmentMonths) ? `${term} · ${source.installmentMonths}개월 할부` : term
}

/** 사업자 수 — 「3곳」, 0 이상의 정수가 아니면(POS2LITE · 신청 전) 빈 글자 */
const unitCountText = (count) => (Number.isInteger(count) && count >= 0 ? `${count}곳` : '')

/** 보너스 — 「2개월(첫 결제 기간)」(§26.1 — 처음 내는 기간에 한 번만), 0·없음이면 빈 글자 */
const bonusMonthsText = (months) => (Number.isInteger(months) && months > 0 ? `${months}개월(첫 결제 기간)` : '')

/**
 * 사업자 수 글 — 「3곳」, 다음 결제의 수(`nextUnits`)가 지금 상한과 다르면 「8곳(다음 결제부터 6곳)」(§26.15 — 이용 중 줄이면 이번 기간은 낸
 * 수를 그대로 쓴다). 신청 전이면 빈 글자. 순수.
 */
const unitsText = (source) => {
  const units = unitCountText(source.units)
  const next =
    Number.isInteger(source.nextUnits) && source.nextUnits !== source.units ? unitCountText(source.nextUnits) : ''
  return units && next ? `${units}(다음 결제부터 ${next})` : units
}

/**
 * 남은 사업자 추가 결제 안내 — 서버가 판정한 남은 줄(`addonLines` — 칸이 없으면 없음)이 있으면 「사업자 추가 결제 N건은 청구 내역에서 따로
 * [청구 취소]로 돌려주세요」, 없으면 빈 글자. 중도 해지 창과 구독료 줄 청구 취소 확인이 같이 쓴다(§26.9 · §26.16 — 창은 세지 않고 서버 줄의 수만). 순수.
 */
const addonRemainText = (lines) => {
  const count = Array.isArray(lines) ? lines.length : 0
  return count > 0
    ? `사업자 추가 결제 ${count}건은 청구 내역에서 따로 [${SUBSCRIPTION_TEXT.cancelCharge}]로 돌려주세요`
    : ''
}

/**
 * **멀티 구독의 사업자·보너스 줄**(목록 칸 — §26.7) — 「사업자 3곳」(줄여 둔 구독은 「사업자 8곳(다음 결제부터 6곳)」, 신청 전은 뺀다) ·
 * 「보너스 2개월(첫 결제 기간)」(보너스가 있을 때만). 값이 없는 줄은 뺀다 — POS2LITE 는 새 칸이 null 이라 빈 목록이다. 금액은 서버가
 * 지금 사업자 수로 준 `price`·`listPrice` 그대로다([priceLinesOf]). 순수.
 *
 * @param {?{units: ?number, nextUnits: ?number, bonusMonths: ?number}} row
 * @returns {Array<string>}
 */
export function multiLinesOf(row) {
  const source = row || {}
  const units = unitsText(source)
  const bonus = bonusMonthsText(source.bonusMonths)
  const unitsLine = units && `사업자 ${units}`

  return [unitsLine, bonus && `${SUBSCRIPTION_TEXT.labelBonus} ${bonus}`].filter(Boolean)
}

/**
 * **금액과 정가** — 낸(낼) 금액, 정가와 다르면 정가 줄(`정가 198,000원`). 금액이 없으면 둘 다 빈 글자. 표는 두 줄로, 상세는 한 줄
 * ([priceText])로 그린다. 다시 셈하지 않는다 — 두 값 모두 서버 스냅샷이다(§3.3·§21.3). 순수.
 *
 * @param {?number} amount 결제 금액·청구 금액
 * @param {?number} listAmount 견줄 정가 — 청구 줄은 같은 기간의 정가(`listAmount`), 구독 행은 월 정가
 * @param {string} [listLabel] 정가 줄의 이름(기본 「정가」)
 * @returns {{main: string, list: string}}
 */
export function amountLinesOf(amount, listAmount, listLabel) {
  const main = wonText(amount)
  if (!main) return { main: '', list: '' }

  return {
    main,
    list:
      typeof listAmount === 'number' && listAmount !== amount ? `${listLabel || '정가'} ${wonText(listAmount)}` : '',
  }
}

/**
 * **구독의 결제 금액 두 줄** — 한 번 결제 금액(`price`)과, 선결제라 다르면 월 정가(`listPrice` — 「월 정가 33,000원」). 무약정은 둘이
 * 같아 한 줄이다. 신청 전은 빈 글자. 순수.
 *
 * @param {?{price: ?number, listPrice: ?number}} row
 * @returns {{main: string, list: string}}
 */
export function priceLinesOf(row) {
  return amountLinesOf(row && row.price, row && row.listPrice, '월 정가')
}

/**
 * **결제 금액 한 줄** — `178,200원 (월 정가 33,000원)`. 신청 전은 빈 글자. 순수.
 *
 * @param {?{price: ?number, listPrice: ?number}} row
 * @returns {string}
 */
export function priceText(row) {
  const lines = priceLinesOf(row)

  return lines.list ? `${lines.main} (${lines.list})` : lines.main
}

/**
 * **지금 낸 기간** — 지금을 덮는 승인 구독료 줄의 시작(`paidFrom`)부터 결제 끝(`paidThrough`)까지(§21.5). 지금 덮는 줄이 없으면(첫 결제
 * 전·끝난 뒤) 빈 글자. 순수.
 *
 * @param {?{paidFrom: ?string, paidThrough: ?string}} row
 * @returns {string}
 */
export function paidPeriodText(row) {
  return periodText(row && row.paidFrom, row && row.paidThrough)
}

/**
 * **다음 결제** — 서버 `nextChargeAt`(덮인 끝 — `SubscriptionRules.coveredEnd`)의 KST 날짜. 정기결제 꺼짐·지정 중·체험 미정이면 서버가
 * null 을 주고 빈 글자다(셈·판정은 서버 한 곳). 순수.
 *
 * @param {?{nextChargeAt: ?string}} row
 * @returns {string}
 */
export function nextChargeText(row) {
  return dateText(row && row.nextChargeAt)
}

/** 카드번호를 가리는 글자 — 번호가 와도 안 와도 같은 자리에 둔다(11-02 사용자 — 할부 설계 §6 2번을 바꿈) */
const CARD_MASK = '****'

/**
 * **결제 카드** — 지금 카드의 이름(`cardName`) 뒤에 가린 번호: 뒤 4자리(`cardLast4`)가 오면 「KB국민카드 **** 1234」, 안 오면(리얼은
 * 헥토 상점 설정 전이라 흔하다 — 할부 설계 §2) 「KB국민카드 ****」. 이름이 없으면(카드 없음·칸 없는 옛 서버) 빈 글자 — 상세에 줄이
 * 없어 지금 화면 그대로다. 서버가 지금 카드에서 읽은 값을 옮길 뿐이다. 순수.
 *
 * @param {?{cardName: ?string, cardLast4: ?string}} row
 * @returns {string}
 */
export function cardText(row) {
  const name = pickedText(row && row.cardName)
  if (!name) return ''

  const last4 = pickedText(row.cardLast4)
  return last4 ? `${name} ${CARD_MASK} ${last4}` : `${name} ${CARD_MASK}`
}

/** 해지한 사람 — 앱에서 끈 것은 「사장님(앱)」, 그 밖은 관리자 계정 그대로 */
export function canceledByText(canceledBy) {
  if (!canceledBy) return ''
  return canceledBy === OWNER_CANCELER ? '사장님(앱 「잠시 중단하기」)' : String(canceledBy)
}

/** **지정 표지** — 「지정 ~12-31」(끝 날짜, KST) · 「지정 무기한」(끝 없음). 순수 */
export function grantMarkText(grant) {
  const until = grant && formatKstIso('MM-dd', grant.untilDtm)

  return until ? `지정 ~${until}` : `지정 ${SUBSCRIPTION_TEXT.grantForever}`
}

/**
 * **지정 단추·창의 이름** — 지정 중이면 「지정 바꾸기」(같은 입구로 요금제·끝을 바꾸거나 늘린다), 아니면 「요금제 지정」. 상세 칸 머리의
 * 단추와 지정 창의 제목·실행 단추가 같은 말이다. 순수.
 *
 * @param {?object} grant 상세의 `grant`(지정 중일 때만 값)
 */
export function grantActionText(grant) {
  return grant ? SUBSCRIPTION_TEXT.grantChange : SUBSCRIPTION_TEXT.grant
}

/**
 * **풀기 창의 정기결제 안내** — 정기결제가 켜져 있으면(상세의 `applied`) 풀자마자 다음 결제 회차가 청구한다(지정해도 동의·결제 방식 칸을
 * 지우지 않는다 — §20.5). 꺼져 있으면 빈 글자. 순수.
 */
export function ungrantNoticeOf(detail) {
  return detail && detail.applied === true ? SUBSCRIPTION_TEXT.ungrantRecurring : ''
}

/**
 * **상세의 지정 칸** — 지정 중이면 요금제·지정 끝(없으면 무기한)·때·누가·사유, 아니면 빈 목록. 마지막 지정 끝(푼 때와 지난 지정 끝 중 늦은
 * 것 — 서버 `grantEndedDtm`)이 있으면 끝에 붙인다(지정 중이 아닐 때도). 순수.
 *
 * @param {?{grant: ?{planCode: string, planName: ?string, untilDtm: ?string, grantedDtm: ?string, grantedBy: ?string,
 *   reason: ?string}, grantEndedDtm: ?string}} detail
 * @returns {Array<{label: string, value: string}>}
 */
export function grantRowsOf(detail) {
  const source = detail || {}
  const grant = source.grant
  const dash = (value) => value || '—'
  const ended = dateTimeText(source.grantEndedDtm)
  const rows = grant
    ? [
        { label: SUBSCRIPTION_TEXT.columnPlan, value: dash(grant.planName || planText(grant.planCode)) },
        {
          label: SUBSCRIPTION_TEXT.labelGrantUntil,
          value: dateTimeText(grant.untilDtm) || SUBSCRIPTION_TEXT.grantForever,
        },
        { label: SUBSCRIPTION_TEXT.labelGrantedDtm, value: dash(dateTimeText(grant.grantedDtm)) },
        { label: SUBSCRIPTION_TEXT.labelGrantedBy, value: dash(pickedText(grant.grantedBy)) },
        { label: SUBSCRIPTION_TEXT.labelGrantReason, value: dash(pickedText(grant.reason)) },
      ]
    : []

  return ended ? rows.concat([{ label: SUBSCRIPTION_TEXT.labelGrantEnded, value: ended }]) : rows
}

/**
 * **고른 매장의 구독 행 묻기**(목록의 [매장 체험] — 10-31 사용자 결정) — 목록 입구에 `storeCd` 를 주면 그 매장의 POS2LITE 행(형제면
 * 대표 행)이 0~1행으로 같은 쪽 봉투에 온다. 순수.
 *
 * @param {number} storeCd
 * @returns {{url: string, params: {storeCd: number}}}
 */
export function storeRowQueryOf(storeCd) {
  return { url: SUBSCRIPTION_ADMIN_API, params: { storeCd } }
}

/** **그 매장에 구독 행이 있는가** — [storeRowQueryOf] 의 답(쪽 봉투)에 줄이 있다. 순수 */
export function hasStoreRow(page) {
  return pageRows(page).length > 0
}

/**
 * **매장 코드인가** — 양의 정수. 지정 창의 「매장을 골랐다」([SubscriptionGrantDialog] 의 단추)와 지정 요청([grantRequestOf])이 같은
 * 규칙을 쓴다. 순수.
 */
export function isStoreCd(value) {
  return Number.isInteger(value) && value > 0
}

/** 지정 끝을 정하는 두 길 — 날짜·시각(기본) / 무기한(「유료처럼 쓰는 매장」 상시 지정 — §25.5, 명시적으로 고른다) */
export const GRANT_UNTIL_MODE = Object.freeze({ DATE: 'date', FOREVER: 'forever' })

/**
 * **지정 창의 처음 값** — 지정 중이면 지금 요금제·끝을 채운다(끝 없는 지정은 무기한으로 — 바꾸기·늘리기). 지정 중이 아니면 요금제는 비우고
 * (고르게 한다) 끝은 날짜·시각 갈래의 빈 칸이다. 순수.
 *
 * @param {?{planCode: string, untilDtm: ?string}} grant 상세의 `grant`(지정 중일 때만 값)
 * @returns {{planCode: string, untilMode: string, untilPicked: string}}
 */
export function grantFormOf(grant) {
  if (!grant) return { planCode: '', untilMode: GRANT_UNTIL_MODE.DATE, untilPicked: '' }

  const picked = formatKstIso(KST_PICK_FORMAT, grant.untilDtm) || ''

  return {
    planCode: grant.planCode || '',
    untilMode: picked ? GRANT_UNTIL_MODE.DATE : GRANT_UNTIL_MODE.FOREVER,
    untilPicked: picked,
  }
}

/**
 * **지정 요청** — 매장(`storeCd` 양의 정수)·요금제(라이트·라이트 플러스)·지정 끝(무기한 = `untilDtm: null`, 날짜·시각 = 고른 KST 시각의
 * `+09:00` ISO, 지금보다 뒤)·사유(필수, 앞뒤 공백 뗌)를 차례로 보고, 고칠 칸을 값으로 돌려준다. 순수.
 *
 * @param {?{storeCd: ?number, planCode: ?string, untilMode: ?string, untilPicked: ?string, reason: ?string}} input
 * @param {number} nowMs 지금(epoch ms — 부르는 쪽이 시계를 읽는다)
 * @returns {{ok: true, url: string, body: {storeCd: number, planCode: string, untilDtm: ?string, reason: string}}
 *   |{ok: false, problem: string, field: string}}
 */
export function grantRequestOf(input, nowMs) {
  const { storeCd, planCode } = input || {}
  const reason = reasonOf(input)

  if (!isStoreCd(storeCd)) return { ok: false, problem: SUBSCRIPTION_TEXT.grantStoreRequired, field: 'storeCd' }
  if (!SUBSCRIPTION_PLAN_OPTIONS.some((option) => option.value === planCode)) {
    return { ok: false, problem: SUBSCRIPTION_TEXT.grantPlanRequired, field: 'planCode' }
  }
  const until =
    input.untilMode === GRANT_UNTIL_MODE.FOREVER ? { ok: true, iso: null } : pickedFutureOf(input.untilPicked, nowMs)
  if (!until.ok) return { ok: false, problem: until.problem, field: 'untilPicked' }
  if (!reason) return { ok: false, problem: SUBSCRIPTION_TEXT.reasonRequired, field: 'reason' }

  return { ok: true, url: `${SUBSCRIPTION_ADMIN_API}/grant`, body: { storeCd, planCode, untilDtm: until.iso, reason } }
}

/**
 * **풀기 요청** — 사유 필수. 순수.
 *
 * @returns {{ok: true, url: string, body: {reason: string}}|{ok: false, problem: string}}
 */
export function ungrantRequestOf(subscriptionId, input) {
  return reasonRequestOf(subscriptionId, 'ungrant', input)
}

/** 사유만 싣는 구독 쓰기(멈추기·풀기·신청 취소) — `POST …/{id}/{verb}` `{reason}`, 사유가 비면 고칠 것 */
const reasonRequestOf = (subscriptionId, verb, input) => {
  const reason = reasonOf(input)
  if (!reason) return { ok: false, problem: SUBSCRIPTION_TEXT.reasonRequired }

  return { ok: true, url: `${SUBSCRIPTION_ADMIN_API}/${subscriptionId}/${verb}`, body: { reason } }
}

/**
 * **그 사이 지정이 풀렸다**(409 `NOT_GRANTED`) — 오류가 아니라 답이다: 화면은 다시 읽는다(인터셉터 토스트는 끈다). 순수.
 *
 * @param {*} error `HttpError` — `status`·`data`
 */
export function isNotGranted(error) {
  return isConflictOf(error, NOT_GRANTED_CODE)
}

/** 서버 `OwnerRejected` 의 409 중 그 코드인가(`HttpError` — `status`·`data.code`) */
const isConflictOf = (error, code) => {
  const body = error && error.data

  return !!error && error.status === 409 && !!body && body.code === code
}

/** 0·6·12 처럼 수로 고른 값만 싣는다(빈 글자 = 전체) */
const pickedNumber = (value) => (typeof value === 'number' && Number.isFinite(value) ? value : null)

/** 비지 않은 글자만 */
const pickedText = (value) => (typeof value === 'string' ? value.trim() : '')

/**
 * **구독 목록 조회 조건** — 거르기를 계약의 질의로. 빈 거르기는 키를 싣지 않는다(무약정 `0` 은 거르기다 — 싣는다). 순수.
 *
 * @param {?{product?: string, status?: string, planCode?: string, termMonths?: (number|string), q?: string}} filter
 * @param {?object} paging
 * @returns {object}
 */
export function subscriptionListQuery(filter, paging) {
  const { product, status, planCode, termMonths, q } = filter || {}
  const query = {}

  if (pickedText(product)) query.product = product
  if (STATUS_VIEWS[status]) query.status = status
  if (pickedText(planCode)) query.planCode = planCode
  if (pickedNumber(termMonths) !== null) query.termMonths = termMonths
  if (pickedText(q)) query.q = pickedText(q)

  return Object.assign(query, paging || {})
}

/**
 * **청구 내역 조회 조건** — 구독 번호(상세에서 넘어온 범위)·시도일·검색어. 순수.
 *
 * @param {?{subscriptionId?: ?number, period?: ?Array<string>, q?: string}} filter
 * @param {?object} paging
 * @returns {object}
 */
export function chargeListQuery(filter, paging) {
  const { subscriptionId, period, q } = filter || {}
  const query = {}

  if (pickedNumber(subscriptionId) !== null) query.subscriptionId = subscriptionId
  if (Array.isArray(period) && period[0] && period[1]) Object.assign(query, { from: period[0], to: period[1] })
  if (pickedText(q)) query.q = pickedText(q)

  return Object.assign(query, paging || {})
}

/**
 * **부분 환불한 줄인가** — 취소한 금액(`cancelAmount`)이 승인 금액보다 작다(§21.10 — 중도 해지가 남은 금액만 돌려준 줄). 이 칸이 생기기
 * 전에 취소한 줄은 `cancelAmount` 가 null 이고 전액으로 읽는다. 순수.
 */
const partiallyRefunded = (row) => typeof row.cancelAmount === 'number' && row.cancelAmount < row.amount

/** **청구 줄을 쓸 수 있는 끝** — 해지로 앞당긴 끝(`usedUntil`), 없으면 기간 끝(§21.10 — 서버 판정의 「줄의 끝」과 같은 뜻) */
const chargeUsableEnd = (row) => row.usedUntil || row.periodEnd

/**
 * **쓸 수 있는 마지막 날** — `2027년 3월 20일`. 서버의 끝은 반열림(그 순간 전까지)인데 「○까지 쓸 수 있어요」는 그 날을 넣어 읽힌다 —
 * 그래서 끝 바로 앞 순간의 KST 날짜를 적는다(회사 귀책 해지의 끝 = 해지한 날 다음 날 00:00 → 해지한 날). 선결제는 해를 넘기므로(최대
 * 24개월) 해를 적는다. 읽을 수 없으면 빈 글자. 순수.
 *
 * @param {?string} iso
 * @returns {string}
 */
export function usableUntilText(iso) {
  const ms = typeof iso === 'string' && iso ? Date.parse(iso) : NaN

  return Number.isNaN(ms) ? '' : formatKst('yyyy년 M월 d일', ms - 1)
}

/**
 * **청구 줄의 결과** — 취소됐으면 「취소됨」(부분 환불한 줄은 「부분 환불」 — 그 줄은 남은 개월만큼 여전히 낸 줄이다), 아니면 시도
 * 결과(승인·거절·확인 중·보내는 중). 거절이면 헥토 사유를, 취소가 안 됐으면 그 사유를 덧붙인다. 순수.
 *
 * @param {?object} row
 * @returns {{label: string, tone: string, note: string}}
 */
export function chargeResultViewOf(row) {
  const source = row || {}
  if (source.canceledDtm) return { label: partiallyRefunded(source) ? '부분 환불' : '취소됨', tone: 'idle', note: '' }

  const view = CHARGE_RESULT_VIEWS[source.result] || { label: source.result ? String(source.result) : '', tone: 'idle' }
  const declined = source.result === 'DECLINED' ? pickedText(source.resultMsg) || pickedText(source.resultCd) : ''
  const cancelFailed = source.cancelResultCd
    ? `취소 안 됨 — ${pickedText(source.cancelResultMsg) || source.cancelResultCd}`
    : ''

  return { label: view.label, tone: view.tone, note: declined || cancelFailed }
}

/** **청구 줄의 기간** — 그 줄이 덮는 기간(`2026-12-20 ~ 2027-06-20`). 기간이 없는 줄(옛 dev 줄)은 빈 글자. 순수 */
export function chargePeriodText(row) {
  return periodText(row && row.periodStart, row && row.periodEnd)
}

/**
 * **청구 줄의 할부** — 그 결제에 보낸 할부(`installmentMonths`): 0 「일시불」 · 2 이상 「3개월」, 헥토가 무이자라고 알려 준 줄
 * (`interestFree` 참)은 「3개월 · 무이자」(거짓·모름은 개월만 — 할부 설계 §6). 이 칸 전 줄(null)·칸 없는 옛 서버는 빈 글자 — 표가 「—」로
 * 그린다(다른 칸과 같은 규칙). 순수.
 *
 * @param {?{installmentMonths: ?number, interestFree: ?boolean}} row
 * @returns {string}
 */
export function chargeInstallmentText(row) {
  const months = row ? row.installmentMonths : null
  if (months == null) return ''
  if (!isInstallment(months)) return SUBSCRIPTION_TEXT.installmentNone

  return row.interestFree === true ? `${months}개월 · 무이자` : `${months}개월`
}

/**
 * **취소 칸의 부분 환불 줄** — 「부분 환불 310,200원 · 2027년 3월 20일까지」(§21.10). 전액 취소 줄·취소하지 않은 줄은 빈 글자(취소 칸은
 * 지금 그대로). 돌려줄 돈이 0 인 중도 해지는 끝을 앞당기지 않으므로(서버) 취소 없는 줄에 남는 표시는 없다. 순수.
 *
 * @param {?{canceledDtm: ?string, amount: ?number, cancelAmount: ?number, usedUntil: ?string, periodEnd: ?string}} row
 * @returns {string}
 */
export function chargeRefundText(row) {
  if (!row || !row.canceledDtm || !partiallyRefunded(row)) return ''

  const until = usableUntilText(chargeUsableEnd(row))

  return `부분 환불 ${wonText(row.cancelAmount)}${until ? ` · ${until}까지` : ''}`
}

/**
 * **보상으로 늘린 줄** — 쓸 수 있는 끝(`usedUntil`)이 산 기간의 끝(`periodEnd`)보다 뒤이고 취소하지 않은 줄이면 「보상 2027년 5월 20일까지」
 * (§25.9 — 이용 기간 늘리기는 그 줄의 쓸 수 있는 끝을 늘린다). 그 밖은 빈 글자. 순수.
 *
 * @param {?{canceledDtm: ?string, usedUntil: ?string, periodEnd: ?string}} row
 * @returns {string}
 */
export function chargeBonusText(row) {
  if (!row || row.canceledDtm || !row.usedUntil || !row.periodEnd) return ''
  if (!(Date.parse(row.usedUntil) > Date.parse(row.periodEnd))) return ''

  return `보상 ${usableUntilText(row.usedUntil)}까지`
}

/**
 * **청구 취소 단추를 그리는가** — 승인됐고 아직 취소하지 않은 줄, 세션이 그 액션을 가질 때. 취소할 수 있는지의 최종 판정은 서버다
 * (409 `CHARGE_NOT_CANCELABLE`). 순수.
 */
export function chargeCancelable(row, can) {
  return (
    !!row &&
    row.result === 'APPROVED' &&
    !row.canceledDtm &&
    typeof can === 'function' &&
    can(SUBSCRIPTION_ADMIN_ACTION.CHARGE_CANCEL)
  )
}

/** 청구 줄의 종류 — `tbl_subscription_charge.kind` 의 사업자 추가(§26.2 — 기간 중 사업자를 더하며 남은 기간만 낸 줄) */
const ADDON_KIND = 'ADDON'

/**
 * **사업자 추가 줄인가** — 줄의 `kind` 가 `ADDON`. 청구 내역의 표지와 청구 취소의 말(확인·끝 문장 — 해지 동반 여부)이 이 판정 하나를
 * 쓴다(중도 해지 창의 남은 줄 안내는 서버 견적의 `addonLines` — [terminationViewOf]). 순수.
 */
export function isAddonCharge(row) {
  return !!row && row.kind === ADDON_KIND
}

/**
 * **청구 줄의 사업자 추가 표지** — 사업자 추가 줄이면 「사업자 추가」(테두리 배지의 색)와 더한 수 「+2곳」(`units` — 없으면 빈 글자), 그
 * 밖(구독료 줄 · 옛 위약금 줄)은 `null`(종류 열·거르기는 두지 않는다 — 줄 안 표지). 순수.
 *
 * @param {?{kind: string, units: ?number}} row
 * @returns {?{label: string, tone: string, count: string}}
 */
export function chargeAddonMarkOf(row) {
  if (!isAddonCharge(row)) return null

  return {
    label: SUBSCRIPTION_TEXT.addonMark,
    tone: 'info',
    count: Number.isInteger(row.units) && row.units > 0 ? `+${row.units}곳` : '',
  }
}

/**
 * **청구 취소 확인 문장** — 전액이고 되돌릴 수 없다. 구독료 줄은 해지를 동반한다(Q10 — 그 기간이 비면 다음 회차가 같은 기간을 다시
 * 청구하기 때문이다). 사업자 추가 줄은 그 줄만 돌려주고 구독은 그대로다(§26.6 — 돌려준 사업자는 지금 사업자 수에서 빠진다). 순수.
 */
export function chargeCancelText(row) {
  const source = row || {}
  const who = subscriberText(source)

  if (isAddonCharge(source)) {
    return `${who} — ${wonText(
      source.amount
    )} 전액을 취소합니다. 이 사업자 추가 결제만 돌려주고 구독은 그대로 둡니다. 되돌릴 수 없습니다.`
  }

  const addon = addonRemainText(source.addonLines)
  return `${who} — ${wonText(source.amount)} 전액을 취소하고 이 구독을 해지합니다. 되돌릴 수 없습니다.${
    addon ? ` ${addon}.` : ''
  }`
}

/** 사유 칸 공통 — 앞뒤 공백을 떼고 비지 않아야 한다 */
const reasonOf = (input) => pickedText(input && input.reason)

/**
 * **청구 취소 요청** — 경로·본문, 또는 고칠 것(사유 필수 — 값으로). 순수.
 *
 * @returns {{ok: true, url: string, body: {reason: string}}|{ok: false, problem: string}}
 */
export function chargeCancelRequestOf(chargeId, input) {
  const reason = reasonOf(input)
  if (!reason) return { ok: false, problem: SUBSCRIPTION_TEXT.reasonRequired }

  return { ok: true, url: `${SUBSCRIPTION_CHARGE_API}/${chargeId}/cancel`, body: { reason } }
}

/**
 * **청구 취소 200 의 갈래** — 줄에 `canceledDtm` 이 찼으면 끝났다(구독료 줄은 「구독도 해지했습니다」, 사업자 추가 줄은 「구독은
 * 그대로입니다」 — [isAddonCharge]). 비었으면 헥토가 취소하지 않았다(값으로 온 실패) — 그 사유를 말한다. 순수.
 *
 * @param {?object} row 200 본문(바뀐 청구 줄)
 * @returns {{done: true, message: string}|{done: false, message: string}}
 */
export function chargeCancelOutcomeOf(row) {
  if (row && row.canceledDtm) {
    return {
      done: true,
      message: isAddonCharge(row) ? SUBSCRIPTION_TEXT.addonCanceledDone : SUBSCRIPTION_TEXT.canceledDone,
    }
  }

  const reason = (row && (pickedText(row.cancelResultMsg) || pickedText(row.cancelResultCd))) || ''

  return { done: false, message: reason ? `카드 취소가 되지 않았습니다 — ${reason}` : SUBSCRIPTION_TEXT.writeFailed }
}

/**
 * **해지 요청** — 사유 필수(§21.4 — 사유만 받는다). 순수.
 *
 * @returns {{ok: true, url: string, body: {reason: string}}|{ok: false, problem: string}}
 */
export function stopRequestOf(subscriptionId, input) {
  return reasonRequestOf(subscriptionId, 'stop', input)
}

/**
 * **자동 결제 멈추기 창의 설명** — 하는 일 그대로(§21.4 — 낸 기간 끝까지 쓰고 그 뒤 잠긴다, 돌려주는 돈 없음). 날짜는 상세의 결제
 * 끝(`paidThrough` — 「지금 낸 기간」의 끝)을 「○까지」의 날로([usableUntilText]), 없으면(첫 결제 전) 날짜 없이. 순수.
 *
 * @param {?{paidThrough: ?string}} detail
 * @returns {string}
 */
export function stopNoticeOf(detail) {
  const until = usableUntilText(detail && detail.paidThrough)

  return `낸 기간 끝${until ? `(${until})` : ''}까지 쓰고, 그 뒤 자동 결제가 멈춰요. 돌려드리는 돈은 없어요.`
}

/**
 * 중도 해지의 까닭 — 서버 `rule` 글자(§21.10 · 약관 제20조). `OWNER` 사장님 해지(③ — 선결제는 할인을 되돌리고 남은 금액, 매월 결제는
 * 그 달까지) · `COMPANY` 회사 귀책·바뀐 약관 거부(⑥ — 남은 날 수만큼, 10-28 ⑤ 삭제 전에는 ⑦). 돌려줄 금액의 셈은 서버 한 곳이다 — 이 화면은 셈하지 않는다.
 */
export const TERMINATION_RULE_OPTIONS = Object.freeze([
  Object.freeze({ value: 'OWNER', label: '사장님 해지' }),
  Object.freeze({ value: 'COMPANY', label: '회사 귀책·바뀐 약관 거부' }),
])

/** **셈 읽기 요청** — 고른 까닭(라디오 값)으로. 순수 */
export function terminationQueryOf(subscriptionId, rule) {
  return { url: `${SUBSCRIPTION_ADMIN_API}/${subscriptionId}/termination`, params: { rule } }
}

/**
 * **중도 해지 요청** — 까닭(둘 중 하나)·사유(필수 — 해지와 같은 검사)를 차례로 보고, 고칠 칸을 값으로 돌려준다. 순수.
 *
 * @param {number} subscriptionId
 * @param {?{rule: ?string, reason: ?string}} input
 * @returns {{ok: true, url: string, body: {rule: string, reason: string}}|{ok: false, problem: string, field: string}}
 */
export function terminateRequestOf(subscriptionId, input) {
  const rule = input && input.rule
  const reason = reasonOf(input)

  if (!TERMINATION_RULE_OPTIONS.some((option) => option.value === rule)) {
    return { ok: false, problem: SUBSCRIPTION_TEXT.terminateRuleRequired, field: 'rule' }
  }
  if (!reason) return { ok: false, problem: SUBSCRIPTION_TEXT.reasonRequired, field: 'reason' }

  return { ok: true, url: `${SUBSCRIPTION_ADMIN_API}/${subscriptionId}/terminate`, body: { rule, reason } }
}

/** 셈 근거 한 줄 — 응답 칸만으로(월 정가는 응답에 없다 — 화면이 다시 셈하지 않는다) */
const terminationBasisOf = (estimate) => {
  const counted =
    estimate.rule === 'COMPANY'
      ? `전체 ${estimate.totalDays}일 중 쓴 날 ${estimate.usedDays}일`
      : `${estimate.usedMonths}개월 쓴 것으로 셈 (전체 ${estimate.totalMonths}개월)`

  return `낸 금액 ${wonText(estimate.paidAmount)} · ${counted}`
}

/**
 * **셈 → 창의 줄** — 서버가 셈한 값(`GET …/termination`)을 말로 옮긴다:
 *
 * - 정산할 줄이 없으면(`chargeId` null) 「돌려줄 결제가 없어요 — 해지만 해요」 하나.
 * - 이미 환불한 줄이면 「이미 환불한 결제예요」와 쓸 수 있는 끝.
 * - 그 밖은 돌려줄 금액 · 쓸 수 있는 끝 · 셈 근거.
 *
 * 실행 단추는 돌려줄 금액이 있으면 「환불하고 해지」, 없으면 「해지」. 결과를 모르는 결제가 있으면(`chargePending`) 「결제 결과를 확인하는
 * 중이에요 — {실행 단추}를 누르면 먼저 확인해요」 한 줄을 더한다(단추는 그대로 — 실행 때 서버가 먼저 맞춘다). 중도 해지는 구독료 줄만
 * 정산하므로(§26.9) 서버가 판정한 남은 사업자 추가 줄(`addonLines` — 칸이 없으면 없음으로)이 있으면 어느 갈래든 「사업자 추가 결제 N건은
 * 청구 내역에서 따로 [청구 취소]로 돌려주세요」 한 줄을 더한다(창은 세지 않고 서버 줄의 수만 말한다). 셈을 아직 읽지 않았으면 `null`(창은
 * 단추를 그리지 않는다). 순수.
 *
 * @param {?object} estimate
 * @returns {?{refund: string, usable: string, basis: string, note: string, pending: string, addon: string, submit: string}}
 */
export function terminationViewOf(estimate) {
  if (!estimate) return null

  const submit = estimate.refundAmount > 0 ? SUBSCRIPTION_TEXT.terminateWithRefund : SUBSCRIPTION_TEXT.terminateOnly
  const pending = estimate.chargePending ? `결제 결과를 확인하는 중이에요 — ${submit}를 누르면 먼저 확인해요` : ''
  const addon = addonRemainText(estimate.addonLines)
  if (estimate.chargeId == null) {
    return { refund: '', usable: '', basis: '', note: SUBSCRIPTION_TEXT.terminateNoCharge, pending, addon, submit }
  }

  const until = usableUntilText(estimate.usedUntil)
  const usable = until ? `${until}까지 쓸 수 있어요` : ''
  if (estimate.alreadyRefunded) {
    return { refund: '', usable, basis: '', note: SUBSCRIPTION_TEXT.terminateAlreadyRefunded, pending, addon, submit }
  }

  return {
    refund: `돌려줄 금액 ${wonText(estimate.refundAmount)}`,
    usable,
    basis: terminationBasisOf(estimate),
    note: '',
    pending,
    addon,
    submit,
  }
}

/**
 * **중도 해지 200 의 갈래**(`{subscription, charge, refundAmount}`):
 *
 * - 돌려줄 금액이 있고 그 줄이 취소됐으면 — 「N원 환불하고 해지했어요 · ○까지 쓸 수 있어요」.
 * - 돌려줄 금액이 있는데 줄이 취소되지 않았으면 헥토가 거절했거나 답이 없다(서버는 해지하지 않았다) — 「환불하지 못했어요 — {사유}.
 *   해지하지 않았어요」(사유는 응답 그대로).
 * - 돌려줄 금액이 없으면 — 「돌려줄 금액 없이 해지했어요 · ○까지 쓸 수 있어요」(정산할 줄이 없으면 끝 없이).
 *
 * 순수.
 *
 * @param {?object} body
 * @returns {{done: boolean, message: string}}
 */
export function terminateOutcomeOf(body) {
  const source = body || {}
  const charge = source.charge || null

  if (source.refundAmount > 0 && !(charge && charge.canceledDtm)) {
    const reason = charge ? pickedText(charge.cancelResultMsg) || pickedText(charge.cancelResultCd) : ''

    return {
      done: false,
      message: reason ? `환불하지 못했어요 — ${reason}. 해지하지 않았어요` : '환불하지 못했어요. 해지하지 않았어요',
    }
  }

  const until = charge ? usableUntilText(chargeUsableEnd(charge)) : ''
  const tail = until ? ` · ${until}까지 쓸 수 있어요` : ''

  return {
    done: true,
    message:
      source.refundAmount > 0
        ? `${wonText(source.refundAmount)} 환불하고 해지했어요${tail}`
        : `돌려줄 금액 없이 해지했어요${tail}`,
  }
}

/** 고르는 칸의 형식 — 화면에 보이는 꼴이자 고른 값(`value-format`)의 꼴. KST 벽시계로 읽는다(이 앱의 달력은 KST — `kstDate`) */
export const KST_PICK_FORMAT = 'yyyy-MM-dd HH:mm'

/** 고른 값(`2026-11-05 09:00`) → 서버가 받는 ISO(`2026-11-05T09:00:00+09:00`), 꼴이 다르면 빈 글자 */
const pickedKstIso = (picked) => {
  const match = /^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2})$/.exec(pickedText(picked))

  return match ? `${match[1]}T${match[2]}:00+09:00` : ''
}

/**
 * **고른 시각 → 보낼 ISO, 또는 고칠 것** — 고르지 않았거나 꼴이 다르면 「골라 주십시오」, 지금보다 뒤가 아니면 「지금보다 뒤」. 날짜 칸이 있는
 * 창(체험 기간 정하기·매장 체험·지정 끝·이용 기간 늘리기)이 같이 쓴다. 나머지 판정(체험 시작 앞·산 기간의 끝 앞 …)은 서버다
 */
const pickedFutureOf = (picked, nowMs) => {
  const iso = pickedKstIso(picked)
  if (!iso) return { ok: false, problem: SUBSCRIPTION_TEXT.pickRequired }
  if (Date.parse(iso) <= nowMs) return { ok: false, problem: SUBSCRIPTION_TEXT.pickPast }

  return { ok: true, iso }
}

/**
 * **달력에서 못 고르는 날** — 아래 끝 순간(`floorMs` — 보통 지금, 이용 기간 늘리기는 산 기간의 끝과 지금 중 늦은 것)의 KST 날짜보다 앞선 날.
 * 달력 칸은 이 브라우저의 자정 `Date` 라 그 KST 날짜를 같은 꼴로 견준다(`kstTodayLocal`). 그 날 안의 앞선 시각은 요청이 거른다. 순수.
 *
 * @param {Date} date 달력 칸의 날
 * @param {number} floorMs 아래 끝(epoch ms — 지금이면 부르는 쪽이 시계를 읽는다)
 */
export function pickDayDisabled(date, floorMs) {
  return date.getTime() < kstTodayLocal(floorMs).getTime()
}

/** 체험 끝을 정하는 두 길 — 지금 끝내기(서버 시계) / 날짜·시각 고르기 */
export const TRIAL_END_MODE = Object.freeze({ NOW: 'now', PICK: 'pick' })

/** 체험 기간 정하기의 세 갈래 — 서버 판정(§25.4 `trialSetOf`)과 같은 상태 나눔. 시작 전 「체험 시작」 · 체험 중 「바꾸기」 · 유예·멈춤 「다시 체험」 */
export const TRIAL_SET_KIND = Object.freeze({ START: 'start', CHANGE: 'change', RESTART: 'restart' })

/** 갈래별 창 — 제목 · 「지금 끝내기」를 고를 수 있는가(체험 중만) · 끝난 말 */
const TRIAL_SET_VIEWS = Object.freeze({
  [TRIAL_SET_KIND.START]: Object.freeze({
    title: SUBSCRIPTION_TEXT.trialStart,
    canEndNow: false,
    done: SUBSCRIPTION_TEXT.trialStartDone,
  }),
  [TRIAL_SET_KIND.CHANGE]: Object.freeze({
    title: SUBSCRIPTION_TEXT.trialEnd,
    canEndNow: true,
    done: SUBSCRIPTION_TEXT.trialEndDone,
  }),
  [TRIAL_SET_KIND.RESTART]: Object.freeze({
    title: SUBSCRIPTION_TEXT.trialRestart,
    canEndNow: false,
    done: SUBSCRIPTION_TEXT.trialStartDone,
  }),
})

/**
 * **체험 기간 정하기의 갈래** — 상태로: 시작 전(체험 빔) → 체험 시작(지금부터 고른 끝까지) · 체험 중 → 바꾸기(지금 끝내기 / 날짜·시각) ·
 * 그 밖(유예·멈춤 — 서버가 `TRIAL_SET` 을 싣는 나머지) → 다시 체험(지금부터 고른 끝까지, 처음 시작한 날은 그대로). 단추를 그릴지는
 * [opAllowed] 가 정한다 — 이것은 창의 말만 가른다. 순수.
 *
 * @param {?{status: string}} detail
 * @returns {string} [TRIAL_SET_KIND]
 */
export function trialSetKindOf(detail) {
  const status = detail && detail.status
  if (status === 'NOT_STARTED') return TRIAL_SET_KIND.START
  if (status === 'TRIAL') return TRIAL_SET_KIND.CHANGE

  return TRIAL_SET_KIND.RESTART
}

/** **갈래의 창** — 제목·「지금 끝내기」 여부·끝난 말. 순수 */
export function trialSetViewOf(kind) {
  return TRIAL_SET_VIEWS[kind] || TRIAL_SET_VIEWS[TRIAL_SET_KIND.CHANGE]
}

/** **지금 체험 기간** — 시각까지(`2026-08-22 09:00 ~ 2026-10-21 09:00`). 한쪽이라도 없으면 빈 글자. 순수 */
export function trialPeriodText(detail) {
  return periodText(detail && detail.trialStartDtm, detail && detail.trialEndDtm, dateTimeText)
}

/**
 * **체험 기간 정하기 창의 안내 한 줄** — 끝난 뒤 일어나는 일(기존 규칙 그대로 — §25.4): 해지한 구독이면 유예 없이 잠김 · 신청이 있으면
 * 신청한 요금제로 결제(체험 중 「바꾸기」면 [지금 청구]로 바로 결제하는 길도) · 없으면 유예 뒤 잠김(유예 일수는 서버 설정이라 적지 않는다).
 * 순수.
 *
 * @param {?{applied: ?boolean, canceledDtm: ?string}} detail
 * @param {string} kind [TRIAL_SET_KIND]
 * @returns {string}
 */
export function trialSetNoticeOf(detail, kind) {
  const source = detail || {}
  if (source.canceledDtm) return SUBSCRIPTION_TEXT.trialSetCanceled
  if (source.applied === true) {
    return kind === TRIAL_SET_KIND.CHANGE ? SUBSCRIPTION_TEXT.trialEndApplied : SUBSCRIPTION_TEXT.trialSetApplied
  }

  return SUBSCRIPTION_TEXT.trialEndNotApplied
}

/**
 * **체험 기간 정하기 요청** — 지금 끝내기는 `trialEndDtm: null`(서버 시계 — 브라우저 시계 어긋남을 피한다), 고르기는 고른 KST 시각의
 * `+09:00` ISO(지금보다 뒤) · 사유 필수(§25.10 Q1). 고칠 칸을 값으로 돌려준다(체험 시작보다 앞 같은 나머지 판정은 서버다). 순수.
 *
 * @param {number} subscriptionId
 * @param {?{mode: string, picked: ?string, reason: ?string}} input `picked` 는 [KST_PICK_FORMAT] 꼴
 * @param {number} nowMs 지금(epoch ms)
 * @returns {{ok: true, url: string, body: {trialEndDtm: ?string, reason: string}}|{ok: false, problem: string, field: string}}
 */
export function trialSetRequestOf(subscriptionId, input, nowMs) {
  const end =
    input && input.mode === TRIAL_END_MODE.NOW ? { ok: true, iso: null } : pickedFutureOf(input && input.picked, nowMs)
  if (!end.ok) return { ok: false, problem: end.problem, field: 'picked' }

  const reason = reasonOf(input)
  if (!reason) return { ok: false, problem: SUBSCRIPTION_TEXT.reasonRequired, field: 'reason' }

  return {
    ok: true,
    url: `${SUBSCRIPTION_ADMIN_API}/${subscriptionId}/trial-end`,
    body: { trialEndDtm: end.iso, reason },
  }
}

/**
 * **매장 체험 요청**(목록 [매장 체험] — 행이 없는 매장도) — 매장(양의 정수)·체험 끝(고른 KST 시각, 지금보다 뒤)·사유(필수)를 차례로 보고
 * 고칠 칸을 값으로 돌려준다. 그 매장이 이용 중·지정 중이면 서버가 409 `TRIAL_UNAVAILABLE`. 순수.
 *
 * @param {?{storeCd: ?number, picked: ?string, reason: ?string}} input
 * @param {number} nowMs 지금(epoch ms)
 * @returns {{ok: true, url: string, body: {storeCd: number, trialEndDtm: string, reason: string}}
 *   |{ok: false, problem: string, field: string}}
 */
export function storeTrialRequestOf(input, nowMs) {
  const storeCd = input && input.storeCd
  if (!isStoreCd(storeCd)) return { ok: false, problem: SUBSCRIPTION_TEXT.grantStoreRequired, field: 'storeCd' }

  const end = pickedFutureOf(input.picked, nowMs)
  if (!end.ok) return { ok: false, problem: end.problem, field: 'picked' }

  const reason = reasonOf(input)
  if (!reason) return { ok: false, problem: SUBSCRIPTION_TEXT.reasonRequired, field: 'reason' }

  return { ok: true, url: `${SUBSCRIPTION_ADMIN_API}/trial`, body: { storeCd, trialEndDtm: end.iso, reason } }
}

/**
 * **신청 취소 요청**(체험 중 관리자 신청 취소 — §25.6) — 사유 필수. 체험·유예는 그대로 두고 정기결제 신청만 비운다(서버가 앱의 신청 취소와 같은
 * 판정·쓰기). 순수.
 *
 * @returns {{ok: true, url: string, body: {reason: string}}|{ok: false, problem: string}}
 */
export function withdrawRequestOf(subscriptionId, input) {
  return reasonRequestOf(subscriptionId, 'withdraw', input)
}

/**
 * **새 이용 끝의 아래 끝** — 산 기간의 끝(`extend.periodEnd` — 사실, 보상을 되돌리는 끝)과 지금 중 늦은 것(§25.9). 달력이 이 날보다 앞을
 * 막는다. 순수.
 *
 * @param {?{periodEnd: ?string}} extend 상세의 `extend`
 * @param {number} nowMs 지금(epoch ms)
 * @returns {number}
 */
export function extendFloorMs(extend, nowMs) {
  const periodEndMs = extend && extend.periodEnd ? Date.parse(extend.periodEnd) : NaN

  return Number.isNaN(periodEndMs) ? nowMs : Math.max(periodEndMs, nowMs)
}

/**
 * **이용 기간 늘리기 창의 줄** — 지금 이용 끝(`usableUntil` — 늘린 끝이 있으면 그것) · 산 기간의 끝(`periodEnd` — 앞당겨도 여기까지). 시각까지,
 * 빈 값은 「—」. 순수.
 *
 * @param {?{periodEnd: ?string, usableUntil: ?string}} extend
 * @returns {Array<{label: string, value: string}>}
 */
export function extendRowsOf(extend) {
  const source = extend || {}

  return [
    { label: SUBSCRIPTION_TEXT.extendCurrent, value: dateTimeText(source.usableUntil) || '—' },
    { label: SUBSCRIPTION_TEXT.extendPaidEnd, value: dateTimeText(source.periodEnd) || '—' },
  ]
}

/**
 * **이용 기간 늘리기 요청** — 새 이용 끝(고른 KST 시각 — 지금보다 뒤, 산 기간의 끝보다 앞은 안 됨: 앞당기기는 거기까지 — 잘못 준 보상
 * 되돌리기)·사유(필수). 고칠 칸을 값으로 돌려준다. 순수.
 *
 * @param {number} subscriptionId
 * @param {?{periodEnd: ?string}} extend 상세의 `extend`
 * @param {?{picked: ?string, reason: ?string}} input
 * @param {number} nowMs 지금(epoch ms)
 * @returns {{ok: true, url: string, body: {usableUntilDtm: string, reason: string}}|{ok: false, problem: string, field: string}}
 */
export function extendRequestOf(subscriptionId, extend, input, nowMs) {
  const end = pickedFutureOf(input && input.picked, nowMs)
  if (!end.ok) return { ok: false, problem: end.problem, field: 'picked' }
  if (Date.parse(end.iso) < extendFloorMs(extend, nowMs)) {
    return { ok: false, problem: SUBSCRIPTION_TEXT.extendBeforeFloor, field: 'picked' }
  }

  const reason = reasonOf(input)
  if (!reason) return { ok: false, problem: SUBSCRIPTION_TEXT.reasonRequired, field: 'reason' }

  return {
    ok: true,
    url: `${SUBSCRIPTION_ADMIN_API}/${subscriptionId}/extend`,
    body: { usableUntilDtm: end.iso, reason },
  }
}

/** 작업 기록의 동작 이름 — 서버 `tbl_subscription_admin_log.action` 글자(§25.7). 모르는 동작은 받은 글자 그대로 */
const LOG_ACTION_LABELS = Object.freeze({
  TRIAL_SET: SUBSCRIPTION_TEXT.columnTrialEnd,
  GRANT: SUBSCRIPTION_TEXT.grant,
  UNGRANT: SUBSCRIPTION_TEXT.ungrant,
  WITHDRAW: SUBSCRIPTION_TEXT.withdraw,
  EXTEND: SUBSCRIPTION_TEXT.logExtend,
  STOP: SUBSCRIPTION_TEXT.stop,
  TERMINATE: SUBSCRIPTION_TEXT.terminate,
  CHARGE_CANCEL: SUBSCRIPTION_TEXT.cancelCharge,
  CHARGE_NOW: SUBSCRIPTION_TEXT.chargeNow,
})

/** 기록 값의 시각 — 기록한 해와 같으면 `MM-dd HH:mm`, 다르면 해까지(선결제·보상은 해를 넘긴다) */
const logMomentText = (iso, refYear) =>
  formatKstIso(formatKstIso('yyyy', iso) === refYear ? 'MM-dd HH:mm' : 'yyyy-MM-dd HH:mm', iso)

/** 헥토 취소의 답 — 서버 `SubscriptionAdminRules.cancelValue` 글자(청구 취소·중도 해지 기록의 값) */
const CANCEL_ANSWER_LABELS = Object.freeze({ CANCELED: '취소됨', REFUSED: '취소 안 됨', UNKNOWN: '확인 중' })

/** `|` 로 나눈 칸 — 칸 수가 다르면 `null`(모르는 꼴) */
const logFields = (text, count) => {
  const fields = text.split('|')

  return fields.length === count ? fields : null
}

/** 숫자 글자만 수로(`"6"` → 6), 아니면 `null` */
const digitsOf = (text) => (/^\d+$/.test(text) ? Number(text) : null)

/**
 * **동작별 기록 값 읽기** — 서버 `SubscriptionAdminRules` 의 작업 기록 값 함수(§25.7 F)가 내는 꼴 그대로. 읽지 못하면 `null`(받은 글자 그대로
 * 그린다):
 *
 * - 체험 끝(`timeValue`)·이용 끝(`kstValue`) — ISO 시각.
 * - 지정·풀기(`grantValue`) — `요금제|끝`(끝이 비면 무기한).
 * - 신청 취소(`applicationValue`) — `요금제|결제 방식 개월`(0 = 무약정 — 멀티는 월 결제).
 * - 중도 해지(`terminationValue`) — `까닭|돌려줄 돈|헥토 취소의 답`(돌려줄 돈 0 이면 답 칸이 빈다).
 * - 지금 청구 — 그 줄의 결과 코드(`APPROVED`…) · 청구 취소(`cancelValue`) — 헥토 취소의 답.
 */
const LOG_VALUE_READERS = Object.freeze({
  TRIAL_SET: (text, refYear) => (/^\d{4}-\d{2}-\d{2}T/.test(text) && logMomentText(text, refYear)) || null,
  EXTEND: (text, refYear) => LOG_VALUE_READERS.TRIAL_SET(text, refYear),
  GRANT: (text, refYear) => {
    const fields = logFields(text, 2)
    if (!fields || !fields[0]) return null
    if (!fields[1]) return `${planText(fields[0])} ${SUBSCRIPTION_TEXT.grantForever}`

    const until = LOG_VALUE_READERS.TRIAL_SET(fields[1], refYear)
    return until ? `${planText(fields[0])} ~${until}` : null
  },
  UNGRANT: (text, refYear) => LOG_VALUE_READERS.GRANT(text, refYear),
  WITHDRAW: (text, refYear, product) => {
    const fields = logFields(text, 2)
    const months = fields && digitsOf(fields[1])
    if (months == null) return null

    return [planText(fields[0]), termMonthsText(months, product)].filter(Boolean).join(' · ')
  },
  TERMINATE: (text) => {
    const fields = logFields(text, 3)
    const refund = fields && digitsOf(fields[1])
    if (refund == null) return null

    const rule = TERMINATION_RULE_OPTIONS.find((option) => option.value === fields[0])
    const answer = fields[2] ? CANCEL_ANSWER_LABELS[fields[2]] || fields[2] : ''

    return [rule ? rule.label : fields[0], refund > 0 ? `환불 ${wonText(refund)}` : '돌려줄 금액 없음', answer]
      .filter(Boolean)
      .join(' · ')
  },
  CHARGE_NOW: (text) => (CHARGE_RESULT_VIEWS[text] ? CHARGE_RESULT_VIEWS[text].label : null),
  CHARGE_CANCEL: (text) => CANCEL_ANSWER_LABELS[text] || null,
})

/** 기록 값 → 말 — 그 동작의 읽기([LOG_VALUE_READERS])로, 모르는 동작·꼴은 받은 글자 그대로. 상품은 결제 방식 이름이 가른다 */
const logValueText = (action, value, refYear, product) => {
  const text = pickedText(value)
  if (!text) return ''

  const read = LOG_VALUE_READERS[action]
  return (read && read(text, refYear, product)) || text
}

/**
 * **작업 기록 줄**(상세 맨 아래 「작업 기록」 — 최근 것부터, 서버 순서 그대로) — 「10-30 17:48 · admin · 체험 끝 12-20 15:30 → 10-30 17:48 ·
 * 사유 …」. 바뀐 값은 앞·뒤가 다 있으면 화살표로, 하나만 있으면 그것만(새로 시작·풀기). 청구가 걸린 기록은 「(청구 #N)」. 한글은 이 파일이
 * 만든다 — 서버는 기계 값만 싣는다. 순수.
 *
 * @param {?{logs: ?Array<{logId: number, action: string, beforeValue: ?string, afterValue: ?string, chargeId: ?number,
 *   reason: ?string, adminId: string, regDtm: string}>}} detail
 * @returns {Array<{logId: number, text: string}>}
 */
export function logLinesOf(detail) {
  const logs = detail && Array.isArray(detail.logs) ? detail.logs : []

  return logs.map((log) => {
    const refYear = formatKstIso('yyyy', log.regDtm)
    const before = logValueText(log.action, log.beforeValue, refYear, detail.product)
    const after = logValueText(log.action, log.afterValue, refYear, detail.product)
    const change = before && after ? `${before} → ${after}` : after || before
    const charge = log.chargeId != null ? ` (청구 #${log.chargeId})` : ''
    const what = `${LOG_ACTION_LABELS[log.action] || pickedText(log.action)}${change ? ` ${change}` : ''}${charge}`
    const reason = pickedText(log.reason)

    return {
      logId: log.logId,
      text: [formatKstIso('MM-dd HH:mm', log.regDtm), pickedText(log.adminId), what, reason ? `사유 ${reason}` : '']
        .filter(Boolean)
        .join(' · '),
    }
  })
}

/** **지금 청구 요청** — 본문 없음(기간·금액은 서버가 정한다). 순수 */
export function chargeRequestOf(subscriptionId) {
  return { url: `${SUBSCRIPTION_ADMIN_API}/${subscriptionId}/charge`, body: {} }
}

/**
 * **지금 청구 창의 줄** — 요금제 · 결제 방식 · 결제 금액(서버 `price` 그대로 — 다시 셈하지 않는다). 결제 방식은 목록·상세와 같은 글
 * ([termText] — 할부면 「· 3개월 할부」: 지금 청구도 신청 스냅샷의 할부로 보낸다, 할부 설계 §3.4). 빈 값은 「—」. 순수.
 *
 * @returns {Array<{label: string, value: string}>}
 */
export function chargeNowRowsOf(detail) {
  const source = detail || {}
  const dash = (value) => value || '—'

  return [
    { label: SUBSCRIPTION_TEXT.columnPlan, value: dash(source.planName || source.planCode) },
    { label: SUBSCRIPTION_TEXT.columnTerm, value: termText(source) },
    { label: SUBSCRIPTION_TEXT.columnPrice, value: dash(wonText(source.price)) },
  ]
}

/** **다시 보내는 결제의 안내** — 지난 결제가 거절이면(`chargeIssue` `DECLINED`) 같은 카드로 다시 보낸다는 한 줄, 아니면 빈 글자. 순수 */
export function chargeRetryNoticeOf(detail) {
  return detail && detail.chargeIssue === 'DECLINED' ? SUBSCRIPTION_TEXT.chargeNowRetry : ''
}

/**
 * **지금 청구 200 의 말** — 줄의 결과(`charge.result`)대로: 승인 「결제했습니다 — {금액}」(success) · 거절 「카드사가 거절했습니다 —
 * {헥토 사유}」(warning) · 그 밖(답 없음 `UNKNOWN` · 보내는 중 `REQUESTED`) 「결제 결과를 확인하는 중입니다.」(warning). 순수.
 *
 * @param {?{charge: ?object}} body
 * @returns {{type: string, message: string}}
 */
export function chargeOutcomeOf(body) {
  const charge = (body && body.charge) || {}

  if (charge.result === 'APPROVED') return { type: 'success', message: `결제했습니다 — ${wonText(charge.amount)}` }
  if (charge.result === 'DECLINED') {
    const reason = pickedText(charge.resultMsg) || pickedText(charge.resultCd)

    return { type: 'warning', message: reason ? `카드사가 거절했습니다 — ${reason}` : '카드사가 거절했습니다.' }
  }

  return { type: 'warning', message: SUBSCRIPTION_TEXT.chargeNowChecking }
}

/**
 * **아직 청구할 때가 아니다(409 `NOT_DUE`)의 말** — 「아직 결제할 때가 아닙니다 — 다음 결제 {날짜}」(날짜는 상세의 `nextChargeAt`, 없으면
 * 날짜 없이). `NOT_DUE` 가 아니면 빈 글자 — 부르는 쪽이 서버 문장을 말한다. 순수.
 *
 * @param {*} error `HttpError` — `status`·`data`
 * @param {?{nextChargeAt: ?string}} detail
 * @returns {string}
 */
export function notDueTextOf(error, detail) {
  if (!isConflictOf(error, NOT_DUE_CODE)) return ''

  const next = nextChargeText(detail)

  return next
    ? `${SUBSCRIPTION_TEXT.chargeNotDue} — ${SUBSCRIPTION_TEXT.labelNextCharge} ${next}`
    : `${SUBSCRIPTION_TEXT.chargeNotDue}.`
}

/**
 * **상세의 칸들** — 구독·결제 방식·해지 칸에 그릴 줄(이름·값). 값이 빈 줄은 빼지 않고 「—」로 둔다(칸이 있다는 것을 보인다). 오더엔 멀티
 * 구독은 구독 칸에 사업자 수(지금 사업자 수 — 신청 전 「—」), 결제 방식 칸에 보너스(첫 결제 기간에 더한 개월 — 없으면 「—」)
 * 줄이 더 있다(§26.7 — POS2 Lite 의 줄은 그대로). 「매장」 줄은 멀티면 「사장님」 줄이고 가입 경로 줄이 없다([subscriberOf]). 결제 방식
 * 칸의 결제 카드 줄([cardText])은 카드 이름이 올 때만 있다 — 카드가 없거나 칸 없는 옛 서버면 줄이 없어 지금 그대로다(할부 설계 §6). 순수.
 *
 * @param {?object} detail `GET /api/admin/subscriptions/{id}` 응답
 * @returns {{basic: Array<{label: string, value: string}>, payment: Array<{label: string, value: string}>,
 *   cancel: Array<{label: string, value: string}>}}
 */
export function detailRowsOf(detail) {
  const source = detail || {}
  const dash = (value) => value || '—'
  const multi = source.product === MULTI_PRODUCT
  const trial =
    source.trialStartDtm || source.trialEndDtm
      ? `${dateText(source.trialStartDtm)} ~ ${dateText(source.trialEndDtm)}`
      : ''
  const unitRows = multi ? [{ label: SUBSCRIPTION_TEXT.labelUnits, value: dash(unitsText(source)) }] : []
  const bonusRows = multi
    ? [{ label: SUBSCRIPTION_TEXT.labelBonus, value: dash(bonusMonthsText(source.bonusMonths)) }]
    : []
  // 가입 경로는 매장의 표지다 — 사장님 구독(멀티)에는 그 줄이 없다([signupPathText])
  const signupRows = multi ? [] : [{ label: SUBSCRIPTION_TEXT.labelSignup, value: dash(signupPathText(source)) }]
  const card = cardText(source)
  const cardRows = card ? [{ label: SUBSCRIPTION_TEXT.labelCard, value: card }] : []

  return {
    basic: [
      { label: SUBSCRIPTION_TEXT.columnProduct, value: dash(productText(source.product)) },
      { label: subscriberOf(source).label, value: dash(subscriberText(source)) },
      ...signupRows,
      { label: SUBSCRIPTION_TEXT.columnPlan, value: dash(source.planName || source.planCode) },
      ...unitRows,
      { label: SUBSCRIPTION_TEXT.columnPrice, value: dash(priceText(source)) },
      { label: SUBSCRIPTION_TEXT.columnFeatures, value: featureTierOf(source) },
      { label: SUBSCRIPTION_TEXT.columnApplied, value: dash(dateTimeText(source.appliedDtm)) },
      { label: SUBSCRIPTION_TEXT.labelTrial, value: dash(trial) },
    ],
    payment: [
      { label: SUBSCRIPTION_TEXT.columnTerm, value: termText(source) },
      ...bonusRows,
      ...cardRows,
      { label: SUBSCRIPTION_TEXT.labelPaidPeriod, value: dash(paidPeriodText(source)) },
      { label: SUBSCRIPTION_TEXT.labelNextCharge, value: dash(nextChargeText(source)) },
    ],
    cancel: source.canceledDtm
      ? [
          { label: SUBSCRIPTION_TEXT.columnCanceled, value: dateTimeText(source.canceledDtm) },
          { label: SUBSCRIPTION_TEXT.labelCanceledBy, value: dash(canceledByText(source.canceledBy)) },
          { label: SUBSCRIPTION_TEXT.labelCancelReason, value: dash(pickedText(source.cancelReason)) },
        ]
      : [],
  }
}
